import { useMemo } from 'react';

import {
    useSearchPlayerBonuses,
    useGetBonusTemplateDetails,
    useSearchPlayerAvailableBonusTemplates
} from 'server';

export const useBonusPublicAPI = () => {
    const searchPlayerBonuses = useSearchPlayerBonuses();
    const getBonusTemplateDetails = useGetBonusTemplateDetails();
    const searchPlayerAvailableBonusTemplates = useSearchPlayerAvailableBonusTemplates();

    return useMemo(() => ({
        /**
         *
         * @memberOf Playtech.API.bonus
         * @function
         * @returns {Promise<{}>}
         * @example
         * Playtech.API.bonus.getBonusTemplateDetails();
         */
        getBonusTemplateDetails,
        /**
         *
         * @memberOf Playtech.API.bonus
         * @function
         * @returns {Promise<{}>}
         * @example
         * Playtech.API.bonus.searchPlayerAvailableBonusTemplates();
         */
        searchPlayerAvailableBonusTemplates,
        /**
         *
         * @memberOf Playtech.API.bonus
         * @function
         * @returns {Promise<{}>}
         * @example
         * Playtech.API.bonus.searchPlayerBonuses();
         */
        searchPlayerBonuses
    }), [
        searchPlayerBonuses,
        getBonusTemplateDetails,
        searchPlayerAvailableBonusTemplates
    ]);
};
